// extracted by css-extract-rspack-plugin
var _1 = "assignment-qW7f1Q";
var _2 = "assignment-list-wkyHW7";
var _3 = "assignment-organization-QOaG2o";
var _4 = "assignment-tag-VtTdAc";
var _5 = "assignment-list-wkyHW7";
var _6 = "assignment-organization-QOaG2o";
var _7 = "assignment-tag-VtTdAc";
var _8 = "details-cow5p_";
var _9 = "edit-form-xkoT8I";
var _a = "edit-form-xkoT8I";
var _b = "notice-sGR2m5";
var _c = "source-group-label-iD5BZl";
var _d = "source-select-S_DEDD";
var _e = "source-group-label-iD5BZl";
var _f = "source-select-S_DEDD";
export { _1 as "assignment", _2 as "assignment-list", _3 as "assignment-organization", _4 as "assignment-tag", _5 as "assignmentList", _6 as "assignmentOrganization", _7 as "assignmentTag", _8 as "details", _9 as "edit-form", _a as "editForm", _b as "notice", _c as "source-group-label", _d as "source-select", _e as "sourceGroupLabel", _f as "sourceSelect" }
